<template>
  <div class="currency-picker">
    <div
      v-for="currency in currencyTypes"
      :key="currency"
      class="currency-picker__item"
      :class="currency === selected_currency && 'active'"
      @click="setCurrency(currency)"
      :id="currency"
    >
      {{ currencyList[currency].sign }}
    </div>
  </div>
</template>

<script>
import currencyList from "@/config/currencies";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      currencyList
    };
  },
  computed: {
    ...mapGetters({
      currencyTypes: "getCurrencySelectList",
      selected_currency: "getSelectedCurrency"
    })
  },
  methods: {
    setCurrency(currency) {
      // По идентификатору определяем выбранную валюту и отправляем ее верхнему компоненту
      this.$store.commit("setSelectedCurrency", currency);
      this.$emit("select-currency", currency);
    }
  }
};
</script>

<style scoped>
.currency-picker {
  margin-top: 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.currency-picker__item {
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 11px;
  line-height: 0;
  text-align: center;
  color: #ffffff;
  border-radius: 50%;
  border: 1px solid #2e79ef;
  cursor: pointer;
  transition: 0.5s;
}

.currency-picker__item:hover {
  background-color: #2e79ef;
}

.currency-picker__item.active {
  background-color: #2e79ef;
}

.currency-picker__item:not(:last-child) {
  margin-right: 10px;
}
</style>
